import { render, staticRenderFns } from "./AreaTrend.vue?vue&type=template&id=1baa51d1&scoped=true&"
import script from "./AreaTrend.vue?vue&type=script&lang=js&"
export * from "./AreaTrend.vue?vue&type=script&lang=js&"
import style0 from "./AreaTrend.vue?vue&type=style&index=0&id=1baa51d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa51d1",
  null
  
)

component.options.__file = "AreaTrend.vue"
export default component.exports